/** Centralized API endpoint constants. */

export const AUTH = {
  LOGIN: '/accounts/login/',
  REFRESH: '/accounts/token/refresh/',
  REGISTER: '/accounts/register/',
  ME: '/accounts/me/',
  CHANGE_PASSWORD: '/accounts/change-password/',
  LOGOUT: '/accounts/logout/',
  REQUEST_OTP: '/accounts/otp/request/',
  VERIFY_OTP: '/accounts/otp/verify/',
  GOOGLE: '/accounts/google/',
} as const;

export const EVENTS = {
  LIST: '/events/',
  CREATE: '/events/',
  DETAIL: (id: string) => `/events/${id}/`,
  UPDATE: (id: string) => `/events/${id}/`,
  DELETE: (id: string) => `/events/${id}/`,
  PHASES: (id: string) => `/events/${id}/phases/`,
  STATS: (id: string) => `/events/${id}/stats/`,
  EXPORT: (id: string) => `/events/${id}/export/`,
} as const;

export const PHOTOS = {
  LIST: '/photos/',
  DETAIL: (id: string) => `/photos/${id}/`,
  UPDATE: (id: string) => `/photos/${id}/`,
  DELETE: (id: string) => `/photos/${id}/`,
  BULK_ACTION: '/photos/bulk_action/',
  SERVE_FILE: (id: string) => `/photos/${id}/serve_file/`,
  SERVE_THUMBNAIL: (id: string) => `/photos/${id}/serve_thumbnail/`,
} as const;

export const UPLOAD = {
  SESSION: '/uploads/sessions/',
  SESSION_DETAIL: (id: string) => `/uploads/sessions/${id}/`,
  REGISTER_FILE: '/uploads/files/',
  CHUNK: (uploadId: string, chunkIndex: number) => `/uploads/files/${uploadId}/chunks/${chunkIndex}/`,
  COMPLETE: (uploadId: string) => `/uploads/files/${uploadId}/complete/`,
  ABORT: (uploadId: string) => `/uploads/files/${uploadId}/abort/`,
  SIMPLE: '/uploads/simple/',
} as const;

export const FACES = {
  PERSONS: '/faces/persons/',
  PERSON_DETAIL: (id: string) => `/faces/persons/${id}/`,
  PERSON_PHOTOS: (id: string) => `/faces/persons/${id}/photos/`,
  PERSON_MERGE: '/faces/persons/merge/',
  WIZARD_STATUS: '/faces/wizard/status/',
  WIZARD_START: '/faces/wizard/start/',
  WIZARD_CLUSTERS: '/faces/wizard/clusters/',
  WIZARD_AMBIGUOUS: '/faces/wizard/ambiguous/',
  WIZARD_DECIDE: '/faces/wizard/decide/',
  WIZARD_RECLUSTER: '/faces/wizard/recluster/',
  WIZARD_UNASSIGNED: '/faces/wizard/unassigned/',
  PERSON_REMOVE_FACES: (id: string) => `/faces/persons/${id}/remove-faces/`,
  PERSON_ASSIGN_FACES: (id: string) => `/faces/persons/${id}/assign-faces/`,
  PERSON_SPLIT: (id: string) => `/faces/persons/${id}/split/`,
} as const;

export const SIMILARITY = {
  GROUPS: '/similarity/groups/',
  GROUP_DETAIL: (id: string) => `/similarity/groups/${id}/`,
  GROUP_UPDATE: (id: string) => `/similarity/groups/${id}/`,
  RUN: '/similarity/groups/run/',
} as const;

export const ANALYSIS = {
  STATUS: '/analysis/status/',
  START: '/analysis/start/',
  STAGES: '/analysis/stages/',
  STAGE_DETAIL: (id: string) => `/analysis/stages/${id}/`,
  HISTORY: '/analysis/history/',
} as const;

export const NOTIFICATIONS = {
  LIST: '/notifications/',
  MARK_READ: '/notifications/mark-read/',
  MARK_ALL_READ: '/notifications/mark-all-read/',
  UNREAD_COUNT: '/notifications/unread-count/',
} as const;

export const SETTINGS = {
  PROFILE: '/settings/profile/',
  PREFERENCES: '/settings/preferences/',
} as const;

export const WS = {
  ANALYSIS_PROGRESS: (eventId: string) => `/ws/analysis/${eventId}/`,
  UPLOAD_PROGRESS: (sessionId: string) => `/ws/upload/${sessionId}/`,
  NOTIFICATIONS: '/ws/notifications/',
} as const;
